module.exports = __webpack_public_path__ + "img/Logo-5.ec4ccadb.svg";